import { cx } from '@emotion/css';
import { Variant } from '@sortlist-frontend/design-system/legacy';
import { FC, Fragment } from 'react';

import { Levels } from '_core/utils/public-links/_types';
import { getLocalizedUrl } from '_core/utils/public-links/getLocalizedUrl';

import * as S from '../styles';

type Props = {
  asideMenu?: string;
  cities: string[];
  className?: string;
  category: Levels;
  levelOne: string;
  levelTwo: string;
  shouldShowDropdownLinks: boolean;
  variant: Variant;
};

export const MainLinkItem: FC<Props> = (props) => {
  const { asideMenu, cities, category, levelOne, levelTwo, shouldShowDropdownLinks } = props;

  return (
    <Fragment>
      {cities.map((levelThree, key) => {
        const links = category[levelOne][levelTwo][levelThree];
        const isEvenNumber = links.length % 2 === 0;
        const itemCount = (isEvenNumber ? links.length : links.length + 1) / 2;

        return (
          <S.Menu
            key={`${category}-${levelOne}-${levelTwo}-${levelThree}-${key}`}
            asideMenu={!!asideMenu ? asideMenu : 'false'}
            className={cx(shouldShowDropdownLinks ? 'show' : 'hide', 'px-3')}>
            {levelThree !== 'null' && <h4 className={'p px-1 mb-2 mt-8 medium'}>{levelThree}</h4>}
            <S.List asideMenu={!!asideMenu ? asideMenu : 'false'} itemCount={itemCount} className="pl-8 pr-4 mt-0">
              {links
                .sort((a, b) => a.position - b.position) // firefox is crazy, messing up arrays order => hydration issues
                .map((link, key) => {
                  const localizedLink = getLocalizedUrl(link);

                  return (
                    <li
                      key={`${levelOne}-${key}-${category}-${levelTwo}-${levelThree}-${link.anchor}`}
                      className="mt-3 text-secondary-500">
                      <S.MainLink href={localizedLink}>{link.anchor}</S.MainLink>
                    </li>
                  );
                })}
            </S.List>
          </S.Menu>
        );
      })}
    </Fragment>
  );
};
